import { format } from 'date-fns';
import { weekDaysNames } from '../../../commom/weekDaysNames';
import { Typography } from '../../molecules/Typography';

interface iEventListHeaderProps {
  type: 'date' | 'title';
  date?: Date;
  title?: string;
}

function EventListHeader({
  type,
  date,
  title,
}: iEventListHeaderProps) {
  const weekDayName = date ? weekDaysNames[date.getDay()] : '';
  const dayAndMonth = date ? format(date, 'dd/MM') : '';

  return (
    <Typography type='titleSection' size='h5'>
      {type === 'date' ? `${weekDayName} - ${dayAndMonth}` : title}
    </Typography>
  );
}

export { EventListHeader };
